<script setup lang="ts">
import { computed } from 'vue'
import { getRainbowColor } from './RainbowColor'

const props = defineProps<{
  size: 'sm' | 'xs' | '2xs' | 'md' | 'lg' | 'xl'
  fullText: string
  noBackground?: boolean
}>()

const color = computed(() => getRainbowColor(props.fullText ?? ''))
const style = computed(() => ({ ...(!props.noBackground && { backgroundColor: color.value }) }))

const getIconText = (fullText: string): string => {
  const words = fullText.split(' ')
  if (props.size === '2xs') {
    return fullText.slice(0, 1)
  }

  let initials = ''
  for (const word of words) {
    if (initials.length >= 2) break
    initials += word.at(0) || ''
  }

  return words.length >= 2 ? initials : fullText.substring(0, 2)
}
const iconText = computed(() => getIconText(props.fullText ?? ''))
</script>

<template>
  <span
    class="flex size-full items-center justify-center uppercase text-text-inverted transition-colors duration-500"
    :class="[
      (size === '2xs' || size === 'xs') && 'text-xxs-8px-default',
      size === 'sm' && 'text-sm-12px-default',
      size === 'md' && 'text-sm-12px-default',
      size === 'lg' && 'text-md-13px-default',
      size === 'xl' && 'text-md-13px-default',
    ]"
    v-bind="$attrs"
    :style="style"
    >{{ iconText }}</span
  >
</template>
